export interface ProductVariantStock {
  productVariantId: number;
  internalEAN?: string;
  productVariantName: string;
  inStockAcquisition: number;
  inStockFidelization: number;
  inStockReserveMarketing: number;
  inStockInfluencerB4A: number;
}
